import { uuid25 } from "../../uuid/dist/uuid25.js";
import { deepMerge } from "../deepMerge.js";
//#region src/utils/collection/tableColumn.entity.ts
var createColumn = (value) => deepMerge({
	id: uuid25(),
	tableId: "",
	name: "",
	comment: "",
	dataType: "",
	default: "",
	options: 0,
	logicalName: "",
	domainId: "",
	ui: {
		keys: 0,
		widthName: 60,
		widthLogicalName: 60,
		widthComment: 60,
		widthDataType: 60,
		widthDomain: 60,
		widthDefault: 60
	}
}, value ?? {});
//#endregion
export { createColumn };
